import React, {useEffect, useState} from "react";
import _ from "lodash";
import GenerateContentFromPrompt from "../../../openai/components/generate-content-from-prompt";

const AddEditProductLink = ({

                                productsList,
                                collectionsList,
                                contentLine,
                                isAddProductLink = false,
                                isEditProductLink = false,
                                afterProductLinksPrepared = undefined
                            }) => {
    const [showModal, setShowModal] = useState(false);
    const [currentProductLink, setCurrentProductLink] = useState(null);
    const [currentLinks, setCurrentLinks] = useState([]);
    const [productLinkFields, setProductLinkFields] = useState([]);
    const [productUrls, setProductUrls] = useState(null);
    const [keywordContent, setKeywordContent] = useState(null);
    const [promptContent, setPromptContent] = useState(null);
    const [keywordMapping, setKeywordMapping] = useState(null);


    useEffect(() => {
        if (showModal) {
            prepareProductLinkFields();
        }
    }, [showModal]);

    const handleConfirmAction = async () => {
        const existingProductLinkFields = [...productLinkFields];
        const filteredProductLinkFields = _.filter(existingProductLinkFields, (productLinkField) => {
            return productLinkField.value !== '';
        });

        afterProductLinksPrepared(filteredProductLinkFields);
        setShowModal(false);
    }

    const prepareProductLinkFields = () => {
        const newProductLinkFields = [];
        let onlineStoreBaseUrl = '';
        const existingLinksMap = _.keyBy(contentLine.links, 'attribute');

        _.forEach(productsList, (product, key) => {
            newProductLinkFields.push({
                attribute: product.id,
                title: product.title,
                type: 'text',
                value: existingLinksMap[product.id] ? existingLinksMap[product.id].value : '',
                url: product.onlineStoreUrl,
                nodeType: 'product',
            });

            if (!onlineStoreBaseUrl) {
                onlineStoreBaseUrl = _.split(product.onlineStoreUrl, '.com')[0];
                onlineStoreBaseUrl += '.com';
            }
        });

        _.forEach(collectionsList, (collection, key) => {
            newProductLinkFields.push({
                attribute: collection.id,
                title: collection.title,
                type: 'text',
                value: existingLinksMap[collection.id] ? existingLinksMap[collection.id].value : '',
                url: onlineStoreBaseUrl + '/collections/' + collection.handle,
                nodeType: 'collection',
            });
        });

        const allUrls = _.map(newProductLinkFields, 'url');
        setProductUrls(allUrls);
        setPromptContent('Extract maximum of 4 exact long-tail keywordMapping from the given content. Map each keyword to a url from the URLs list below. Format the mapping like this: Keyword = URL' +
            '\nURLs need to be mapped only once.' +
            '\nContent: "' + contentLine.text + '"' +
            '\nURLs: ' + _.join(_.chunk(_.shuffle(allUrls), 4)[0], ', '));

        setProductLinkFields(newProductLinkFields);
        setKeywordMapping(null);
    }

    const handleFieldChanges = (event) => {
        const {name, value} = event.target;

        const existingProductLinkFields = [...productLinkFields];
        const productLinkFieldIndex = _.findIndex(existingProductLinkFields, (productLinkField) => {
            return productLinkField.attribute === name;
        });

        existingProductLinkFields[productLinkFieldIndex].value = value;
        setProductLinkFields(existingProductLinkFields);
    }

    const prepareKeywordMapping = (generatedText) => {
        const keywordsList = [];

        const existingProductLinkFields = [...productLinkFields];
        const existingProductLinkFieldsByUrlMap = _.keyBy(existingProductLinkFields, 'url');

        let keywordText, keywordLink;
        _.forEach(_.split(generatedText, '\n'), (line) => {
            if (!_.isEmpty(line) && line.indexOf('http') !== -1) {
                const mapDetail = _.split(line, ' = ');
                keywordText = _.trim(mapDetail[0]);
                keywordLink = _.trim(mapDetail[1]);

                keywordText = _.replace(keywordText, /"/g, '');
                const titleWords = _.split(keywordText, ' ');
                const firstWord = titleWords[0];

                if (_.isNumber(_.toNumber(firstWord))) {
                    keywordText = _.trim(_.replace(keywordText, firstWord, ''));
                }

                keywordsList.push({
                    text: keywordText,
                    link: keywordLink,
                });

                if (existingProductLinkFieldsByUrlMap[keywordLink]) {
                    existingProductLinkFieldsByUrlMap[keywordLink].value = keywordText;
                }
            }
        });

        setProductLinkFields(existingProductLinkFields);
        setKeywordMapping(keywordsList);
    }

    return (
        <>

            {isAddProductLink &&
                <button
                    className="button-sky-outline px-2 py-1 text-sm"
                    onClick={() => setShowModal(true)}>
                    Add Link
                </button>
            }

            {showModal ? (
                <>
                    <div
                        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-x-0 top-0 z-50 outline-none focus:outline-none">
                        <div className="relative my-6 mx-auto w-4/5">
                            {/*content*/}
                            <div
                                className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-gray-100 outline-none focus:outline-none">
                                {/*header*/}
                                <div
                                    className="flex items-start justify-between p-5 border-b border-solid rounded-t">
                                    <h3 className="text-lg font-semibold">
                                        {isAddProductLink &&
                                            <>Add Product Link</>
                                        }

                                        {isEditProductLink &&
                                            <>Edit Product Link</>
                                        }
                                    </h3>
                                    <div>
                                        <GenerateContentFromPrompt
                                            afterContentGenerated={prepareKeywordMapping}
                                            promptTitle={'Keywords'}
                                            promptContent={promptContent}/>
                                    </div>
                                </div>
                                {/*body*/}
                                <div className="relative p-8 flex-auto">
                                    <div
                                        className={`w-full p-4 border border-gray-400 bg-white shadow-lg rounded-xl`}>
                                        <div className={'text-left'}>{contentLine.text}</div>
                                    </div>

                                    <div
                                        className="overflow-y-scroll mt-4 p-4 product-link-container bg-gray-200 rounded-lg border border-gray-400">

                                        <div className={'w-full flex flex-wrap justify-start items-center'}>
                                            {keywordMapping?.map((keyword, keywordIndex) => (
                                                <div key={`product-link-${keywordIndex}`}
                                                     className={'border border-gray-800 py-1 px-2 m-1 rounded text-sm'}>
                                                    {keyword.text} - {keyword.link}
                                                </div>
                                            ))}
                                        </div>


                                        <div className={'w-full text-left'}>
                                            {productLinkFields?.map((productLinkField) => (
                                                <>
                                                    {(productLinkField.value || _.isEmpty(keywordMapping)) &&
                                                        <div key={`product-link-${productLinkField.attribute}`}>
                                                            <div className={`field-container w-full flex items-center`}>
                                                                <input
                                                                    type="text"
                                                                    className="input-field-max w-full"
                                                                    id={productLinkField.attribute}
                                                                    name={productLinkField.attribute}
                                                                    value={productLinkField.value}
                                                                    onChange={handleFieldChanges}>
                                                                </input>
                                                                <div
                                                                    className={`font-semibold w-full ml-3 ${productLinkField?.nodeType === 'product' ? 'text-black' : 'text-purple-500'}`}>
                                                                    {productLinkField.title}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                </>
                                            ))}
                                        </div>

                                    </div>
                                </div>
                                {/*footer*/}
                                <div
                                    className="flex items-center justify-end p-5 border-t border-solid border-blueGray-200 rounded-b">
                                    <button
                                        className="ml-2 text-gray-500 font-bold border border-gray-500 h-10 rounded px-4 outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={() => setShowModal(false)}>
                                        Cancel
                                    </button>
                                    <button
                                        className="ml-2 bg-green-500 text-white active:bg-green-600 h-10 rounded px-4 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={handleConfirmAction}>
                                        Confirm Product Link
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            ) : null}
        </>
    );
}

export default AddEditProductLink
